// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Olt5H","delete":"styles_delete__Um3YO","update":"styles_update__3MRN4","add":"styles_add__212rn"};